import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  TemplateRef,
} from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { tr } from '@util/tr';
import { toast } from '@web/util/toast';
import {
  WsTooltipParsedContent,
  WsTooltipPlacement,
  parseWsTooltipContent,
  WsTooltipContent,
  WsTooltipTemplateContext,
} from './ws-tooltip.types';
import { WsSuperadminService } from './ws-superadmin-copy/ws-superadmin.service';
import { normalizeWsSuperadminCopyValue } from './ws-superadmin-copy/ws-superadmin-copy.util';

@Component({
  selector: 'ws-tooltip-panel',
  templateUrl: './ws-tooltip-panel.component.html',
  styleUrls: ['./ws-tooltip-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WsTooltipPanelComponent {
  parsed: WsTooltipParsedContent | null = null;
  placement: WsTooltipPlacement = 'above';
  arrowLeft = 0;
  panelClass = '';
  adminCopyable = false;
  copyValue = '';
  readonly copyLabel = tr('Copy');
  readonly isSuperadmin$ = this.superadminService.isSuperadmin$;

  @Output() panelMouseEnter = new EventEmitter<void>();
  @Output() panelMouseLeave = new EventEmitter<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private clipboard: Clipboard,
    private superadminService: WsSuperadminService
  ) {}

  setContent(
    content: WsTooltipContent | TemplateRef<any>,
    context?: WsTooltipTemplateContext | null,
    adminCopyable = false
  ): void {
    this.parsed = parseWsTooltipContent(content, context);
    this.adminCopyable = adminCopyable;
    this.copyValue =
      adminCopyable && this.parsed?.type === 'text'
        ? normalizeWsSuperadminCopyValue(this.parsed.text)
        : '';
    this.cdr.markForCheck();
  }

  async copyToClipboard(event: MouseEvent): Promise<void> {
    event.stopPropagation();
    event.preventDefault();
    if (!this.copyValue || !this.clipboard.copy(this.copyValue)) {
      return;
    }
    await toast(tr('Copied to your clipboard.'));
  }

  setPanelClass(panelClass: string): void {
    this.panelClass = panelClass || '';
    this.cdr.markForCheck();
  }

  setPlacement(placement: WsTooltipPlacement, arrowLeft: number): void {
    this.placement = placement;
    this.arrowLeft = arrowLeft;
    this.cdr.markForCheck();
  }

  onPanelMouseEnter(): void {
    this.panelMouseEnter.emit();
  }

  onPanelMouseLeave(): void {
    this.panelMouseLeave.emit();
  }
}
